import { render } from "./Loader.vue?vue&type=template&id=95cc3baa&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=95cc3baa&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cc3baa"]])

export default __exports__